import { Check } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1713638394242-9edf9cf943cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBlb3BsZSUyMGRhcmslMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzc3MDM0ODU4fDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section
      id="grupo"
      data-testid="about-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="nx-blob bg-[#1a103c] w-[600px] h-[600px] -left-40 top-10 opacity-60" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 md:px-8 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <span className="overline">Sobre o grupo</span>
          <h2 className="font-display mt-5 text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.08]">
            Um grupo construído para{" "}
            <span className="text-white/70 italic font-light">integrar tecnologia</span>, entregar
            resultado e sustentar operações.
          </h2>

          <div className="mt-8 space-y-5 text-[15px] md:text-base text-[#b3b0c2] leading-relaxed max-w-xl">
            <p>
              O Grupo Nexus reúne frentes complementares de tecnologia e infraestrutura sob uma única
              governança técnica. Nossa história começou com base em engenharia, execução prática e
              visão de crescimento — e evoluiu para um ecossistema com múltiplas soluções.
            </p>
            <p>
              Atuamos com <strong className="text-white font-medium">conectividade</strong>,{" "}
              <strong className="text-white font-medium">segurança eletrônica</strong>,{" "}
              <strong className="text-white font-medium">infraestrutura técnica</strong> e{" "}
              <strong className="text-white font-medium">inovação digital</strong>, sempre com foco
              em eficiência, qualidade e continuidade.
            </p>
          </div>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl">
            {[
              "Governança técnica própria",
              "Projetos sob medida",
              "Atendimento regional ágil",
              "Capacidade de expansão contínua",
            ].map((i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-white/85">
                <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full border border-white/15 bg-white/[0.04]">
                  <Check size={12} className="text-emerald-300" />
                </span>
                {i}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative">
            <div className="relative rounded-[28px] overflow-hidden border border-white/10 shadow-[0_30px_120px_-20px_rgba(76,46,155,0.35)]">
              <img
                src={ABOUT_IMG}
                alt="Equipe corporativa Grupo Nexus"
                className="w-full h-[460px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/10 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-4">
                <div className="rounded-xl border border-white/15 bg-black/50 backdrop-blur-md px-4 py-3">
                  <div className="font-display text-xl text-white">4 unidades</div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-white/60">
                    Uma única operação
                  </div>
                </div>
                <div className="rounded-xl border border-white/15 bg-black/50 backdrop-blur-md px-4 py-3 text-right">
                  <div className="font-display text-xl nx-rainbow-text">Nexus</div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-white/60">
                    Grupo integrado
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -left-6 hidden md:block rounded-2xl border border-white/10 bg-[#0A0810]/90 backdrop-blur-md p-4 w-56 shadow-xl">
              <div className="text-[11px] uppercase tracking-[0.2em] text-white/55">Nossa missão</div>
              <div className="mt-1 text-sm text-white/90 leading-relaxed">
                Conectar, proteger e estruturar o futuro dos nossos clientes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
